import React, {useEffect} from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import '../Button/button.scss';
import {useDispatch} from 'react-redux';
import { getFeatuerSearch } from '../../slices/vehicleSlice';
import { useTranslation } from 'react-i18next';
import {changePlaceholderStyle, resetPlaceholderStyle} from './compare.method'
const FilterToolbar = ({
                           onSearchFocus,
                           isAdvantageChecked,
                           isFeatureChecked,
                           onFeatureClick,
                           onAdvantageClick,
                           onFilterClick,
                           alwaysOpen,
                           isFilterChecked,
                           buttonHandlerText,
                           expandButtonText,
                           collapseButtonText
                       }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        const searchInput = document.querySelector('#feature-search-input');
        const storedValue = sessionStorage.getItem('featureSearch');
        if (storedValue) {
            searchInput.value = storedValue;
            onSearchFocus(storedValue);
        }
    }, []);

    const onClearInput = () => {
        const searchInput = document.getElementById('feature-search-input');
        const searchIcon = document.getElementById('search-icon');
        const clearIcon = document.getElementById('clear-icon');

        searchInput.value = '';
        dispatch(getFeatuerSearch(null));
        sessionStorage.removeItem('featureSearch');

        searchIcon.style.display = 'inline-block';
        clearIcon.style.display = 'none';
    };

    return (
        <div className={'filter-toolbar'}>
            <div className={'filterToolbarContainer'}>
                <div className={'feature-search-wrap'}>
                    <input
                        className={'form-control'}
                        type={'text'}
                        id={'feature-search-input'}
                        placeholder= { t('features.searchBar.searchPlaceholder')}
                        name={'featureSearch'}
                        onKeyUp={() => onSearchFocus()}
                        onFocus={changePlaceholderStyle}
                        onBlur={resetPlaceholderStyle}
                        data-testid="feature-search-input"
                    />
                    <SearchIcon className="search-icon"
                                id="search-icon"
                               />
                    <CloseIcon
                        className={'clear-icon'}
                        id={'clear-icon'}
                        onClick={() => onClearInput()}
                        data-testid="clear-icon"
                    />
                </div>
            </div>
            <div className={'featureToggles'}>
                <div className={'filter-toggle-checkbox'}>
                    <input
                        type={'checkbox'}
                        className={'checkBox'}
                        onClick={onAdvantageClick}
                        checked={isAdvantageChecked}
                        data-testid={'advantage-checkbox'}
                    />
                    <label className={'checkbox-label'}>
                        {t('features.searchBar.showAdvantages')}{' '}
                        <CheckCircleIcon className={'advantage-icon'} fontSize={'small'} />
                    </label>
                </div>
                <div className={'filter-toggle-checkbox'}>
                    <input
                        type={'checkbox'}
                        name={'Features'}
                        value={'Features'}
                        className={'checkBox'}
                        onClick={onFeatureClick}
                        checked={isFeatureChecked}
                        data-testid={'feature-checkbox'}
                    />
                    <label className={'checkbox-label'}>
                        {t('features.searchBar.showFeature')}
                    </label>
                </div>
                <div className={"filter-toggle-checkbox"}>
                    <input
                        type={'checkbox'}
                        onClick={onFilterClick}
                        className={'checkBox'}
                        checked = {isFilterChecked}
                        data-testid={'differences-checkbox'}
                    />
                    <label className={'checkbox-label'}>
                        {t('features.searchBar.showFilter')}
                    </label>
                </div>
                <div className={'expand-categories'}>
                    <button className={'btn-default btns'}
                            onClick={alwaysOpen}
                            id={"features-expand-collapse"}>
                        <div className={"collapse-icon"}>
                            {buttonHandlerText ? (
                                <ExpandLessIcon />
                            ) : (
                                <ExpandMoreIcon />
                            )}
                        </div>
                        {!buttonHandlerText ? expandButtonText : collapseButtonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterToolbar;